import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

export interface ITerminalStatisticsParams {
  start_time?: string;
  end_time?: string;
}

export interface ITerminalExportParams {
  page?: number;
  page_size?: number;
  start_time?: string;
  end_time?: string;
}

export const getTerminalStatistics = async (params?: ITerminalStatisticsParams) => {
  return await axiosPrivate.get('/dashboard/api/v1/terminals_export/terminal_statistics', {
    params,
  });
};

export const getTerminalExports = async ({
  currentPage,
  pageSize,
  params = {},
}: {
  currentPage: number;
  pageSize: number;
  params: Record<string, string | number | boolean>;
}) => {
  const page = Number(currentPage);
  const validPage = isNaN(page) || page < 1 ? 1 : page;

  const { page: _, ...cleanParams } = params;

  const queryParams = {
    page: validPage,
    page_size: pageSize,
    ...cleanParams,
  };

  return await axiosPrivate.get('/dashboard/api/v1/terminals_export', {
    params: queryParams,
  });
};
